export default "__VITE_ASSET__BA1N22hq__"